/* eslint-disable react/no-danger */
import { memo } from 'react';
import { GetStaticPaths, GetStaticProps } from 'next';
import { END } from 'redux-saga';
import { wrapper, SagaStore } from 'store';
import { REVALIDATE_SECONDS } from '@utils/isr';
import Destination from '@containers/Destination';
import {
  GET_BANNER_DESTINATION,
  GET_DESTINATION,
} from '@containers/Destination/slice';
import { validatePark } from '..';
import { GET_SEO, GET_TRANSLATE } from '@containers/Home/slice';
import { NextSeo } from 'next-seo';
import { useSelector } from 'react-redux';
import { selectSeo } from '@containers/Home/selectors';
import { useRouter } from 'next/router';

function DestinationContainer({ park }: { park: string }) {
  const seo = useSelector(selectSeo);
  const router = useRouter();
  const canonical =
    (typeof window !== 'undefined'
      ? window.location.origin
      : process.env.NEXT_PUBLIC_SITE_URL || '') + router.asPath;
  return (
    <>
      <NextSeo
        title={seo?.title || ''}
        description={seo?.description || ''}
        canonical={canonical}
        openGraph={{
          type: 'website',
          title: seo?.title || '',
          description: seo?.description || '',
          images: seo?.image
            ? [
                {
                  url: seo?.image,
                  width: 800,
                  height: 600,
                  alt: '',
                },
              ]
            : [],
        }}
      />
      <Destination park={park} />
    </>
  );
}

export const getStaticPaths: GetStaticPaths = async () => ({
  paths: [],
  fallback: 'blocking',
});

export const getStaticProps: GetStaticProps = wrapper.getStaticProps(
  store =>
    async ({ params, locale }) => {
      const park = params?.park as string;
      const isValidPark = await validatePark(park);
      if (!isValidPark) {
        return {
          notFound: true,
        };
      }
      store.dispatch(
        GET_SEO({
          locale,
          url: `page/data-page?SiteCode=${park}&page=diem-den`,
        }),
      );
      store.dispatch(GET_DESTINATION({ SiteCode: park, locale, key: '' }));
      store.dispatch(GET_BANNER_DESTINATION({ SiteCode: park, locale }));
      store.dispatch(GET_TRANSLATE({ locale }));
      store.dispatch(END);
      await (store as SagaStore).sagaTask?.toPromise();

      return {
        props: {
          park,
        },
        revalidate: REVALIDATE_SECONDS,
      };
    },
);

export default memo(DestinationContainer);
